<template lang="pug">
    cs-loader(v-if="isLoading")
    .battle-form__body(v-else)
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('battle.battle_battleForm_battleName') }}
            .battle-form__block-body
                cs-input.battle-form__input(
                    v-model="form.name",
                    v-validate="'required'",
                    :data-vv-as="$i18n.t('battle.battle_battleForm_battleName')",
                    name="battle-name"
                )
                help-text(error, slot="help-text", v-if="errors.has('battle-name')") {{ errors.first('battle-name') }}
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('battle.battle_battleForm_schools') }}
            .battle-form__block-body
                cs-multiselect(
                    :options="schools",
                    v-model="form.schools",
                    :placeholder="schoolsPlaceholder",
                    label="name",
                    trackBy="id",
                    :loading="loadingSchools",
                    @open="getSchools",
                    :hideSelected="true",
                    :showNoResults="false",
                    :closeOnSelect="false",
                )
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('battle.battle_battleForm_grades') }}
            .battle-form__block-body
                cs-multiselect(
                    :options="grades",
                    v-model="form.grades",
                    :placeholder="gradesPlaceholder",
                    label="name",
                    trackBy="id",
                    :loading="loadingGrades",
                    @open="getGrades",
                    :hideSelected="true",
                    :showNoResults="false",
                    :disabled="!form.schools.length",
                    :closeOnSelect="false"
                )
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('battle.battle_battleForm_students') }}
            .battle-form__block-body
                cs-multiselect(
                    :options="students",
                    v-model="form.students",
                    :placeholder="studentsPlaceholder",
                    label="fullName",
                    trackBy="id",
                    :loading="loadingStudents",
                    @open="getStudents",
                    :hideSelected="true",
                    :showNoResults="false",
                    :disabled="!form.grades.length",
                    :closeOnSelect="false"
                )
        divider
        .battle-form__block
            .battle-form__label.battle-form__label-datepicker
                | {{ $i18n.t('battle.battle_battleForm_battlePeriod') }}
            .battle-form__block-body
                .input-group.input-group--divided.input-group--datepickers
                    .input-group__col
                        cs-datepicker(
                            :language="user.locale",
                            :value="form.start",
                            :format="customFormatter",
                            @input="form.start = dateToMoment($event, 'YYYY-MM-DDThh:mm:ss')",
                            v-validate="{ date_format: 'YYYY-MM-DDThh:mm:ss' }",
                            :data-vv-as="$i18n.t('battle.battle_battleForm_battleStartDate')",
                            name="start",
                            :placeholder="$i18n.t('olympiads.olympiads_olympiadForm_registrationStartDatePlaceholder')"
                        )
                    .input-group__col.input-group__col--narrow &mdash;
                    .input-group__col
                        cs-datepicker(
                            :language="user.locale",
                            :value="form.end",
                            :format="customFormatter",
                            @input="form.end = dateToMoment($event, 'YYYY-MM-DDThh:mm:ss')",
                            v-validate="{ date_format: 'YYYY-MM-DDThh:mm:ss', after: form.start ? form.start : '' }",
                            :data-vv-as="$i18n.t('battle.battle_battleForm_battleEndDate')",
                            name="end",
                            :placeholder="$i18n.t('olympiads.olympiads_olympiadForm_registrationEndDatePlaceholder')"
                        )
                help-text(error, slot="help-text", v-if="errors.has('end') || errors.has('start')") {{ errors.first('start') || errors.first('end') }}
                cs-button(pattern="primary-outline", color="blue", @click="resetDates") {{ $i18n.t('battle.battle_form_resetDates') }}
        divider
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_paymentService') }}
            .battle-form__block-body
                cs-multiselect(
                    :multiple="false"
                    v-validate="'required'"
                    :options="paymentServices"
                    @open="getPaymentServices"
                    :loading="loadingPaymentServices"
                    :show-labels="false"
                    :allow-empty="false"
                    placeholder=""
                    v-model="form.paymentService"
                    :searchable="false"
                    label="name"
                    track-by="id"
                    data-vv-name="paymentService"
                    :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_paymentService').toLowerCase()"
                )
                help-text(error, slot="help-text", v-if="errors.has('paymentService')") {{ errors.first('paymentService') }}
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_organizationalFee') }}
            .battle-form__block-body
                .input-group.input-group_one-line
                    .input-group__col
                        cs-input.battle-form__input(
                            v-model.number="form.price",
                            type="number",
                            v-validate="'required|min_value:0'",
                            :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_organizationalFee')",
                            name="price"
                        )
                    .input-group__col.input-group__col--narrow {{ $i18n.tc('olympiads.olympiads_olympiadForm_rubles', form.price) }}
                help-text(error, slot="help-text", v-if="errors.has('price')") {{ errors.first('price') }}
        divider
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_userAgreementLink') }}
            .battle-form__block-body
                .input-group
                    .input-group__col
                        cs-input.battle-form__input(
                            v-model="form.termsOfUseLink",
                            type="text",
                            v-validate="'required|url:require_protocol'",
                            :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_userAgreementLink')",
                            name="termsOfUseLink"
                        )
                help-text(error, slot="help-text", v-if="errors.has('termsOfUseLink')") {{ errors.first('termsOfUseLink') }}
        .battle-form__block
            .battle-form__label
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_linkToTheRulesOfTheOlympiad') }}
            .battle-form__block-body
                .input-group
                    .input-group__col
                        cs-input.battle-form__input(
                            v-model="form.rulesLink",
                            type="text",
                            v-validate="'required|url:require_protocol'",
                            :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_linkToTheRulesOfTheOlympiad')",
                            name="rulesLink"
                        )
                help-text(error, slot="help-text", v-if="errors.has('rulesLink')") {{ errors.first('rulesLink') }}
        divider
        .battle-form__block
            .battle-form__label
                | {{$i18n.t('olympiads.olympiads_olympiadForm_cover') }}
            .battle-form__block-body
                cs-image-input(
                    v-model="form.logo",
                    type="battle",
                    @showSizeError="showSizeError",
                    :loadText="$i18n.t('profiles.profiles_common_uploadImage')",
                    :removeText="$i18n.t('profiles.profiles_common_removeImage')"
                    :helpText="$i18n.t('common.common_imageInput_sizeHelpText')",
                    :error="showImageWarning ? imageWarningText : ''"
                    :crop="false"
                )

        template(v-for="(level, index) in form.levels")
            divider
            .battle-form__block-group
                .battle-level__title
                    | {{ $i18n.t('olympiads.olympiads_olympiadForm_group') }}
                    |
                    span(v-text="level.position + 1")
                .battle-level__grid
                    .battle-level__grid-col
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_course') }}
                            .battle-form__block-body
                                cs-multiselect(
                                    :options="courses",
                                    @input="onCourseChangeHandler(level, $event)",
                                    :value="level.course",
                                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                                    @open="getCourses",
                                    :multiple="false",
                                    :allowEmpty="false",
                                    :hide-selected="true",
                                    :loading="loadingCourses",
                                    label="name",
                                    trackBy="id"
                                    v-validate="'required'"
                                    :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_course')",
                                    :name="`courses${index}`"
                                )
                                help-text(error, slot="help-text", v-if="errors.has(`courses${index}`)") {{ errors.first(`courses${index}`) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.tc('olympiads.olympiads_olympiadForm_schools', 1) }}
                            .battle-form__block-body
                                cs-multiselect(
                                    :options="levelSchools(level)",
                                    :value="level.schools",
                                    :placeholder="schoolsPlaceholder",
                                    label="name",
                                    trackBy="id",
                                    :loading="loadingSchools",
                                    @open="getSchools",
                                    @input="onSchoolChangeHandler(level, $event)",
                                    @close="onSchoolCloseHandler()",
                                    :hideSelected="true",
                                    :showNoResults="false",
                                    :disabled="!level.course",
                                    :closeOnSelect="false",
                                )
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.tc('olympiads.olympiads_olympiadForm_grades', 1) }}
                            .battle-form__block-body
                                cs-multiselect(
                                    :options="levelGrades(level)",
                                    :value="level.grades",
                                    :placeholder="gradesPlaceholder",
                                    label="name",
                                    trackBy="id",
                                    :loading="loadingGrades",
                                    @open="getGrades",
                                    @input="onGradeChangeHandler(level, $event)",
                                    @close="onGradeCloseHandler()"
                                    :hideSelected="true",
                                    :showNoResults="false",
                                    :disabled="!(level.schools && level.schools.length)",
                                    :closeOnSelect="false"
                                )
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_students') }}
                            .battle-form__block-body
                                cs-multiselect(
                                    :options="levelStudents(level)",
                                    v-model="level.students",
                                    :placeholder="studentsPlaceholder",
                                    label="fullName",
                                    trackBy="id",
                                    :loading="loadingStudents",
                                    @open="getStudents",
                                    :hideSelected="true",
                                    :showNoResults="false",
                                    :disabled="!(level.grades && level.grades.length)",
                                    :closeOnSelect="false"
                                )
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_theme') }}
                            .battle-form__block-body
                                cs-input.battle-form__input(
                                    v-model="level.theme",
                                    v-validate="'required'",
                                    :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_theme')",
                                    :name="'theme' + index"
                                )
                                help-text(error, slot="help-text", v-if="errors.has('theme' + index)") {{ errors.first('theme' + index) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-form__label
                                | {{ $i18n.t('olympiads.olympiads_olympiadForm_length') + ':' }}
                            .battle-form__block-body
                                .input-group.input-group_one-line
                                    .input-group__col
                                        cs-input.battle-form__input(
                                            v-model.number="level.duration",
                                            type="number",
                                            v-validate="'required|min_value:1'",
                                            :data-vv-as="$i18n.t('olympiads.olympiads_olympiadForm_length')",
                                            :name="'duration' + index"
                                        )
                                    .input-group__col.input-group__col--narrow {{ $i18n.tc('olympiads.olympiads_timeDeclination_minutes', level.duration) }}
                                help-text(error, slot="help-text", v-if="errors.has('duration' + index)") {{ errors.first('duration' + index) }}
                        .battle-form__block.battle-form__block-for-group
                            .battle-level-settings
                                .battle-level-settings__button-container
                                    cs-button.battle-level-settings__button(
                                        pattern="primary-outline", color="blue",
                                        @click="editLevel(index)",
                                        :disabled="!level.course"
                                    )
                                        svg-icon.battle-level-settings__button-item(name="cog")
                                        =" "
                                        span.battle-level-settings__button-item {{ $i18n.t('olympiads.olympiads_olympiadForm_set') }}
                                .battle-level-settings__parameters(v-if="areSettingsNotAvailable(level)")
                                    svg-icon.battle-level-settings__parameters-icon(name="exclamation-circle")
                                    span.battle-level-settings__parameters-text {{ $i18n.t('olympiads.olympiads_olympiadForm_setParameters') }}
                    .battle-level__grid-col.battle-level__grid-col--narrow.battle-level__control-buttons
                        cs-button.battle-level__circle-button.battle-level-settings__close-group(
                            pattern="primary-outline",
                            @click="removeLevel(index)"
                        )
                            svg-icon(name="times", middle)
        divider
        .battle-form__block.battle-form__block--center
            cs-button(
                pattern="primary-outline",
                color="blue",
                @click="addLevel"
                :disabled="!courses.length || (form.levels && form.levels.length === courses.length)"
            )
                svg-icon(name="plus", middle)
                |
                | {{ $i18n.t('olympiads.olympiads_olympiadForm_addIcon') }}
        divider
        .battle-form__block.battle-form__button-group
            cs-button.battle-form__button(pattern="primary-outline", color="blue", @click="$router.back()") {{ $i18n.t('common.common_button_cancel') }}
            =" "
            cs-button.battle-form__button(color="blue" @click="sendForm", :disabled="isLoading")
                cs-loader(v-if="isLoading")
                span {{ $i18n.t('olympiads.olympiads_olympiadForm_publish') }}
</template>

<script>
    import SchoolApi from '../../api/school';
    import GradeApi from '../../api/grade';
    import UserApi from '../../api/user/user';
    import CourseApi from '../../api/course';
    import BattleApi from '../../api/battle';
    import PaymentServicesApi from '../../api/billing/paymentServices';

    import _ from 'lodash';
    import levelTemplate from './config/levelTemplate.json';
    import stageTemplate from './config/stageTemplate.json';
    import moment from 'moment';
    import { mapState } from 'vuex';
    import getBase64FromUrl from '../../utils/getBase64FromUrl';

    export default {
        props: ['id'],
        mixins: [getBase64FromUrl],
        data() {
            return {
                levelTemplate,
                allCourses: [],
                schools: [],
                grades: [],
                students: [],
                paymentServices: [],
                form: {
                    name: '',
                    schools: [],
                    grades: [],
                    students: [],
                    start: null,
                    end: null,
                    logo: null,
                    paymentService: null,
                    price: 0,
                    currency: 'RUB',
                    levels: [],
                    termsOfUseLink: 'http://cleverstart.ru/soglashenie/',
                    rulesLink: 'http://cleverstart.ru/battle',
                },
                loadingPaymentServices: false,
                loadingSchools: false,
                loadingGrades: false,
                loadingStudents: false,
                isLoading: false,
                gradesLoadingAvailable: true,
                studentsLoadingAvailable: true,
                loadingCourses: false,
                imageWarningText: '',
                showImageWarning: false,
            };
        },
        mounted() {
            this.getCourses();
            this.getPaymentServices();
            if (this.id && !this.battle) {
                this.isLoading = true;
                BattleApi.show(this.id)
                    .then(battle => {
                        this.form = _.cloneDeep(battle);
                        this.form.levels.forEach(level => {
                            level.stages.forEach(stage => {
                                stage.games.forEach(game => {
                                    if (game.slug === 'Puzzle') {
                                        this.assignImageForPuzzleGame(game);
                                        game.parameters.default.isImageChanged = false;
                                    }
                                });
                            });
                        });
                        if (battle.start) {
                            this.form.start = this.dateToMoment(battle.start, 'YYYY-MM-DDThh:mm:ss');
                        }
                        if (battle.end) {
                            this.form.end = this.dateToMoment(battle.end, 'YYYY-MM-DDThh:mm:ss');
                        }
                        this.isLoading = false;
                    })
                    .catch(err => {
                        err = err.response && err.response.data ? err.response.data : err;
                        if (err && (err.status_code === 403 || err.status_code === 404)) {
                            this.$toasted.error(this.$root.$t(`errors.${err.message}`));
                        }
                    });
            }
        },
        watch: {
            battle: {
                handler(newBattle) {
                    if (newBattle) {
                        this.form = newBattle;
                    }
                },
                immediate: true,
            },
            'form.logo': {
                handler(val) {
                    if (val) {
                        this.showImageWarning = false;
                        this.imageWarningText = '';
                    }
                },
            },
            'form.schools.length'(newLength, oldLength) {
                if (newLength !== oldLength) {
                    this.gradesLoadingAvailable = true;
                }
                if (newLength < oldLength) {
                    this.form.grades = this.form.grades.filter(grade =>
                        _.find(this.form.schools, { id: grade.schoolId })
                    );
                    this.form.students = this.form.students.filter(student =>
                        _.find(this.form.schools, { id: student.school.id })
                    );
                    this.grades = this.grades.filter(grade => _.find(this.form.schools, { id: grade.schoolId }));
                    this.students = this.students.filter(student =>
                        _.find(this.form.schools, { id: student.school.id })
                    );
                }
            },
            'form.grades.length'(newLength, oldLength) {
                if (newLength !== oldLength) {
                    this.studentsLoadingAvailable = true;
                }
                if (newLength < oldLength) {
                    this.form.students = this.form.students.filter(student =>
                        _.find(this.form.grades, { id: student.grades[0].id })
                    );
                    this.students = this.students.filter(student =>
                        _.find(this.form.grades, { id: student.grades[0].id })
                    );
                }
            },
        },
        methods: {
            async assignImageForPuzzleGame(game) {
                game.parameters.default.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(game.parameters.default.imageSrc)
                );
            },
            dateToMoment(date, format) {
                this.$nextTick(() => {
                    this.$validator.validate('start');
                    this.$validator.validate('end');
                });
                return moment(date).format(format);
            },
            onCourseChangeHandler(level, selected) {
                this.$set(
                    level,
                    'schools',
                    level.schools.filter(school => school.courses.map(course => course.id).includes(selected.id))
                );
                this.$set(
                    level,
                    'grades',
                    level.grades.filter(grade => level.schools.some(school => school.id === grade.school.id))
                );
                this.$set(
                    level,
                    'students',
                    level.students.filter(student =>
                        level.grades.some(grade => student.grades.some(studentGrade => studentGrade.id === grade.id))
                    )
                );
                level.course = selected;
                level.stages = [_.cloneDeep(stageTemplate)];
            },
            onSchoolChangeHandler(level, selected) {
                this.$set(
                    level,
                    'grades',
                    level.grades.filter(grade => selected.some(school => school.id === grade.school.id))
                );
                this.$set(
                    level,
                    'students',
                    level.students.filter(student =>
                        level.grades.some(grade => student.grades.some(studentGrade => studentGrade.id === grade.id))
                    )
                );
                level.schools = selected;
            },
            onSchoolCloseHandler() {
                (this.gradesLoadingAvailable = true) && this.getGrades();
            },
            onGradeChangeHandler(level, selected) {
                this.$set(
                    level,
                    'students',
                    level.students.filter(student =>
                        selected.some(grade => student.grades.some(studentGrade => studentGrade.id === grade.id))
                    )
                );
                level.grades = selected;
            },
            onGradeCloseHandler() {
                (this.studentsLoadingAvailable = true) && this.getStudents();
            },
            areSettingsNotAvailable(level) {
                for (let stage of level.stages) {
                    if (stage.games.length === 0) {
                        return true;
                    }
                }
                return false;
            },
            editLevel(index) {
                this.$store.dispatch('setBattle', this.form);
                this.$router.push({ name: 'battle-level:create', params: { index: index, battleId: this.id } });
            },
            resetDates() {
                this.form.start = null;
                this.form.end = null;
            },
            optimizeForm(form) {
                form.students = form.students.map(student => student.id);
                form.grades = form.grades.map(grade => grade.id);
                form.schools = form.schools.map(school => school.id);
                form.levels = form.levels.map(level => {
                    level.stages.forEach(stage => {
                        stage.startTime = null;
                        stage.endTime = null;
                    });
                    level.students = level.students.length ? level.students.map(student => student.id) : [];
                    level.grades = level.grades.length ? level.grades.map(grade => grade.id) : [];
                    level.schools = level.schools.length ? level.schools.map(school => school.id) : [];
                    level.course_id = level.course.id;
                    return level;
                });
                if (form.start) {
                    form.start = moment(form.start).format('YYYY-MM-DD') + '00:00:00';
                }
                if (form.end) {
                    form.end = moment(form.end).format('YYYY-MM-DD') + '00:00:00';
                }
                form.paymentService = form.paymentService.id;
                if (!form.logo) {
                    delete form.logo;
                }
            },
            sendForm() {
                if (_.isEmpty(this.form.levels)) {
                    this.$toasted.info(this.$i18n.t('olympiads.olympiads_olympiadForm_atLeastOne'));
                    return;
                }
                for (let level of this.form.levels) {
                    if (this.areSettingsNotAvailable(level)) {
                        this.$toasted.info(this.$i18n.t('olympiads.olympiads_olympiadForm_setToContinue'));
                        return;
                    }
                }
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.isLoading = true;
                        let form = _.cloneDeep(this.form);
                        this.optimizeForm(form);
                        this.sendRequest(form)
                            .then(() => {
                                this.isLoading = false;
                                this.$store.dispatch('setBattle', null);
                                this.$router.push({ name: 'battles:index' });
                            })
                            .catch(err => {
                                this.isLoading = false;
                                err = err.response && err.response.data ? err.response.data : err;
                                if (err && (err.status_code === 403 || err.status_code === 404)) {
                                    this.$toasted.error(this.$root.$t(`errors.${err.message}`));
                                }
                            });
                    } else {
                        this.$toasted.info(this.$i18n.t('errors.fill_form'));
                    }
                });
            },
            sendRequest(form) {
                return this.id ? BattleApi.update(this.id, form) : BattleApi.create(form);
            },
            removeLevel(index) {
                this.form.levels.forEach(level => {
                    if (level.position > index) {
                        level.position--;
                    }
                });
                this.form.levels.splice(index, 1);
            },
            addLevel() {
                let level = _.cloneDeep(levelTemplate);
                level.position = this.form.levels.length;
                this.form.levels.push(level);
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({
                    status: 'active',
                    all: true,
                    withGrades: false,
                    withCourses: true,
                })
                    .then(data => {
                        let schools = data.schools;
                        this.schools = schools ? schools : [];
                        this.loadingSchools = false;
                    })
                    .catch(() => {
                        this.loadingSchools = false;
                        this.$toasted.error(this.$i18n.t('errors.getting_schools'));
                    });
            },
            getGrades() {
                let schoolIds = this.grades.length ? _.uniq(this.grades.map(grade => grade.school.id)) : [];
                if (!this.gradesLoadingAvailable || !_.difference(this.getSchoolsIds, schoolIds).length) {
                    return;
                }
                this.loadingGrades = true;
                GradeApi.list({
                    schoolsIds: this.getSchoolsIds,
                    status: 'active',
                    all: true,
                })
                    .then(response => {
                        let grades = response.grades;
                        this.grades = grades ? this.grades.concat(grades) : this.grades;
                        this.gradesLoadingAvailable = false;
                        this.loadingGrades = false;
                    })
                    .catch(() => {
                        this.loadingGrades = false;
                        this.$toasted.error(this.$i18n.t('errors.getting_schools'));
                    });
            },
            getStudents() {
                let gradeIds = this.students.length
                    ? _.uniq(
                          this.students.reduce(
                              (result, student) => result.concat(student.grades.map(grade => grade.id)),
                              []
                          )
                      )
                    : [];
                if (!this.studentsLoadingAvailable || !_.difference(this.getGradesIds, gradeIds).length) {
                    return;
                }
                this.loadingStudents = true;
                UserApi.list({
                    type: 'student',
                    status: 'active',
                    gradesIds: this.getGradesIds,
                    all: true,
                })
                    .then(response => {
                        let students = response.users;
                        this.students = students ? this.students.concat(students) : this.students;
                        this.studentsLoadingAvailable = false;
                        this.loadingStudents = false;
                    })
                    .catch(() => {
                        this.loadingStudents = false;
                        this.$toasted.error(this.$i18n.t('errors.getting_students'));
                    });
            },
            getCourses() {
                if (this.allCourses.length) {
                    return;
                }
                this.loadingCourses = true;
                CourseApi.list({ withLevel: true, withGames: true })
                    .then(response => {
                        let courses = response.courses;
                        this.allCourses = courses ? courses.sort((a, b) => a.level - b.level) : [];
                        this.loadingCourses = false;
                    })
                    .catch(() => {
                        this.loadingCourses = false;
                        this.$toasted.error(this.$i18n.t('errors.getting_students'));
                    });
            },
            getPaymentServices() {
                if (this.paymentServices.length) {
                    return;
                }
                this.loadingPaymentServices = true;
                PaymentServicesApi.list()
                    .then(data => {
                        this.paymentServices = data.data;
                        this.form.paymentService = this.paymentServices[0];
                        this.loadingPaymentServices = false;
                    })
                    .catch(() => {
                        this.loadingPaymentServices = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            getAnswerDurationHelper(index) {
                return this.errors.has('answerDuration' + index)
                    ? this.errors.first('answerDuration' + index)
                    : this.$i18n.t('olympiads.olympiads_olympiadForm_leaveTimeEmpty');
            },
            showSizeError() {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageWeightWarning');
                this.showImageWarning = true;
            },
            levelSchools(level) {
                let schools = [];

                if (level.course) {
                    this.grades.forEach(grade => {
                        const isGradeAvailable =
                            level.course.id === grade.courseId &&
                            !schools.some(school => +school.id === +grade.school.id);

                        if (isGradeAvailable) {
                            schools.push(grade.school);
                        }
                    });
                }

                return schools;
            },
            levelGrades(level) {
                return level.schools.length
                    ? this.grades.filter(
                          grade =>
                              level.schools.some(school => school.id === grade.schoolId) &&
                              grade.courseId === level.course.id
                      )
                    : [];
            },
            levelStudents(level) {
                return level.grades.length
                    ? this.students.filter(student =>
                          level.grades.some(grade => student.grades.map(grade => grade.id).includes(grade.id))
                      )
                    : [];
            },
            customFormatter(date, format = 'D MMM YYYY') {
                return moment(date).format(format);
            },
        },
        computed: {
            ...mapState({
                battle: state => state.battle.battle,
                user: state => state.auth.user,
            }),
            courses() {
                let courses = [];
                if (this.allCourses && this.allCourses.length) {
                    courses = _.cloneDeep(this.allCourses);
                    if (this.form.levels && this.form.levels.length) {
                        this.form.levels.forEach(level => {
                            courses = courses.filter(course => {
                                if (level.course) {
                                    return course.id !== level.course.id;
                                }
                                return true;
                            });
                        });
                    }
                }
                return courses;
            },
            schoolsPlaceholder() {
                if (this.form.schools.length) {
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('olympiads.olympiads_olympiadForm_allSchools');
            },
            studentsPlaceholder() {
                if (this.form.students.length) {
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('olympiads.olympiads_olympiadForm_allStudents');
            },
            gradesPlaceholder() {
                if (this.form.grades.length) {
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('olympiads.olympiads_olympiadForm_allGrades');
            },
            getSchoolsIds() {
                let schoolIds = this.grades.length ? _.uniq(this.grades.map(grade => grade.school.id)) : [];
                return this.form.schools
                    .map(school => school.id)
                    .concat(
                        this.form.levels.reduce(
                            (result, level) => result.concat(level.schools.map(school => school.id)),
                            []
                        )
                    )
                    .filter(school => !schoolIds.some(schoolId => schoolId === school));
            },
            getGradesIds() {
                let gradeIds = this.students.length
                    ? _.uniq(
                          this.students.reduce(
                              (result, student) => result.concat(student.grades.map(grade => grade.id)),
                              []
                          )
                      )
                    : [];
                return this.form.grades
                    .map(grade => grade.id)
                    .concat(
                        this.form.levels.reduce(
                            (result, level) => result.concat(level.grades.map(grade => grade.id)),
                            []
                        )
                    )
                    .filter(grade => !gradeIds.some(gradeId => gradeId === grade));
            },
        },
    };
</script>

<style lang="scss" scoped>
    .battle-form__body {
        width: 100%;
        @include media($xl) {
            width: 70%;
        }
    }

    .battle-form__block {
        display: flex;
        margin-bottom: 20px;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            padding-right: 10%;
        }
    }

    .battle-form__block-group {
        flex-direction: column;
    }

    .battle-form__block-for-group {
        padding-right: 5px;
    }

    .battle-form__label {
        min-width: 13em;
        font-size: 16px;
        line-height: 19px;
        margin: 0 20px 10px 0;
        @include media($md) {
            min-width: 10em;
            width: 35%;
            text-align: right;
            align-self: center;
        }
    }

    .battle-form__label-datepicker {
        align-self: flex-start;
        margin-top: 5px;
    }

    .battle-form__block-body {
        flex-grow: 5;
        width: 100%;
        @include media($md) {
            width: 65%;
        }
    }

    .battle-form__input {
        margin-bottom: 0;
    }

    .battle-form__button {
        margin-bottom: 20px;
        &:not(:last-child) {
            @include media($md) {
                margin-right: 25px;
            }
        }
    }

    .battle-form__block--center,
    .battle-form__button-group {
        justify-content: center;
        @include media($sm) {
            width: 50%;
            margin: 0 auto;
        }
        @include media($md) {
            width: auto;
            padding-left: 40px;
        }
        .svg-icon {
            margin-right: 5px;
        }
        .cs-button {
            @media screen and (min-width: 576px) and (max-width: 585px) {
                padding: 15px 25px;
            }
        }
    }

    .battle-level-settings {
        width: 100%;
        @include make-grid($space-small);
        @include stack-space($space-small);
        @include media($sm) {
            @include make-grid(0);
            @include make-offset(0, 12);
        }
        flex-direction: column;
        align-items: center;
    }

    .battle-level-settings__button-container {
        display: flex;
        justify-content: center;
    }

    .battle-level-settings__button {
        margin-bottom: 5px;
        display: block;
        .svg-icon {
            margin-right: 5px;
        }
    }

    .battle-level-settings__button-item {
        vertical-align: middle;
    }

    .battle-level-settings__parameters {
        @include make-col(12, 12, $space-small);
        text-align: center;
        padding: 15px 0 0 30px;
    }

    .battle-level-settings__parameters-icon {
        vertical-align: middle;
        color: $hsl-color-red-62;
        @include inline-space($space-xx-small);
    }

    .battle-level-settings__parameters-text {
        vertical-align: middle;
        color: $hsl-color-gray-52;
    }

    .battle-level-settings__close-group {
        padding: 0 !important;
    }

    .battle-level__title {
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        @include stack-space($space-base);
        padding-right: 10%;
        position: relative;
    }

    .battle-level__grid {
        @include make-grid;
    }

    .battle-level__grid-col {
        @include make-col;
        padding-right: 0;
        width: 100%;
        @media screen and (min-width: 1440px) and (max-width: 1550px) {
            width: 80%;
            .battle-form__label {
                min-width: 7em;
                width: 30%;
            }
        }
    }

    .battle-level__grid-col--narrow {
        flex: 0;
    }

    .battle-level__control-buttons {
        padding: 10px 15px;
        @media screen and (min-width: 1600px) {
            padding: 10px 25px;
        }
    }

    .battle-level__circle-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 2em;
        height: 2em;
        padding: 0;
        margin: 30px 0 0;
    }

    .input-group {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .input-group_one-line {
        flex-direction: row;
    }

    .input-group--datepickers {
        margin-bottom: 20px;
    }

    .input-group--divided {
        @include media($sm) {
            flex-direction: row;
        }
    }

    .input-group__col {
        flex: 1 1 0;
        width: 100%;
    }

    .input-group__col--narrow {
        flex: 0;
        padding: 10px;
        width: auto;
    }
</style>
